import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const deleteTicketTagById = createAsyncThunk(
  'ticket/deleteTicketTagById',
  async ({ ticketId, tagId }, { rejectWithValue, getState }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;
    const business_id = loginToken?.response?.user?.business_id;
    try {
      const response = await axios.patch(
        `${ROOT_URL}/ticket/${ticketId}/${business_id}/tags/remove`,
        { tags: [tagId] },
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return { ticketId, tagId, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const deleteTicketTagByIdSlice = createSlice({
  name: 'deleteTicketTagById',
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteTicketTagById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteTicketTagById.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(deleteTicketTagById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export default deleteTicketTagByIdSlice.reducer;